import React, { useContext, useEffect, useState } from "react";
import UserCard from "./cards/UserCard";
import { ColorContext } from "../../AppContext";
import { FaPlus } from "react-icons/fa";
import "./Users.css";
import NewUserCard from "./cards/NewUserCard";
import { callApi } from "../../api/useApi";
import Loader from "../Loader";
import { Item, Menu, useContextMenu } from "react-contexify";

function Users() {
  const [theme] = useContext(ColorContext);
  const [newUserShow, setNewUserShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { show } = useContextMenu({
    id: "user-menu",
  });

  const onDeleted = (id) => {
    setUsers(users.filter((user) => user.uid !== id));
  };

  useEffect(() => {
    callApi("listUsers", {}).then((val) => {
      setUsers(val.records.map((e) => e.get("n").properties));
      setLoading(false);
    });
  }, []);

  const onDelete = async ({ uid }) => {
    try {
      await callApi("deleteUser", { uid: uid });
      onDeleted(uid);
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const handleItemClick = async ({ event, props, triggerEvent, data }) => {
    if (data === "delete") {
      const confirmation = window.confirm("Are You Sure You want to Delete?");
      if (confirmation) {
        console.log(props.uid);
        await onDelete({
          uid: props.uid,
        });
      }
    }
  };
  return loading ? (
    <Loader />
  ) : (
    <div>
      <div className="grid-container">
        {users.map((value, i) => {
          return (
            <UserCard
              key={i}
              user={value}
              onContextMenu={(e) =>
                show(e, {
                  props: {
                    ...value,
                  },
                })
              }
            />
          );
        })}
      </div>
      <div
        className="add_letter"
        style={{ backgroundColor: theme }}
        onClick={(event) => {
          event.preventDefault();
          setNewUserShow(true);
        }}
      >
        <FaPlus className="add_icon" />
      </div>
      <NewUserCard
        show={newUserShow}
        onHide={() => setNewUserShow(false)}
        onClick={() => {}}
      />
      <Menu id={"user-menu"}>
        <Item onClick={handleItemClick} data={"delete"}>
          Delete
        </Item>
      </Menu>
    </div>
  );
}

export default Users;